import { queries } from 'RestAPIs/rapini';
import { isValid } from 'date-fns';
import type { HoursPayOutRequestResponse } from 'generated/index';
import { useState } from 'react';
import type { UseDateRangeCalculationOutput } from './useDateRangeCalculation';

interface UseHoursPayOutDataInput {
  dateRange: UseDateRangeCalculationOutput;
  organizationalUnitIds: string;
}

export const useHoursPayOutData = ({
  dateRange,
  organizationalUnitIds
}: UseHoursPayOutDataInput) => {
  'use memo';

  const [onlyToApprove, setOnlyToApprove] = useState(true);

  const {
    data = [],
    isLoading,
    isError,
    refetch
  } = queries.useFindHoursPayOutRequestsByOrganizationalUnits(
    dateRange.startDate,
    dateRange.endDate,
    // @ts-ignore no paramsSerializer is configured on axios, so the ids have to
    // be sent as a comma separated string instead of an array
    organizationalUnitIds as string[],
    onlyToApprove,
    {
      enabled:
        !!organizationalUnitIds &&
        !!dateRange.startDateValue &&
        !!dateRange.endDateValue &&
        isValid(dateRange.startDateValue) &&
        isValid(dateRange.endDateValue) &&
        (!dateRange.isCustomRange || dateRange.hasCompleteCustomRange)
    }
  );

  const rows = data.map((request: HoursPayOutRequestResponse) => ({
    ...request,
    remainingInMinutes: request.currentBalanceInMinutes ?? null
  }));

  return {
    rows,
    isLoading,
    isError,
    refetch,
    onlyToApprove,
    setOnlyToApprove
  };
};
